<div class="container" *ngIf="eventInfo">
  <app-consent
    [consents]="eventInfo.activeConsents" 
    [registerTitle]="'Consent'"
    (onSuccessEvent)="acceptConsent($event)">
  </app-consent>
</div>